import React from 'react';
import PropTypes from 'prop-types';

const IconBatteryHalfStatus = ({ width = 16, height = 16, viewBox = '0 0 16 16' }) => {
    return <svg width={width} height={height} viewBox={viewBox} fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M2 6H8V10H2V6ZM15 6V4H0V12H15V10H16V6H15ZM14 11H1V5H14V11Z' fill='#FFA200' />
    </svg>;
};

IconBatteryHalfStatus.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    viewBox: PropTypes.string,
};

export default IconBatteryHalfStatus;
